import { Component } from '@angular/core';

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.css']
})
export class PreferenceComponent {
  selectedLanguage: string = '';

  showsuccess:boolean=false

  updatesuccessfully()
{
  this.showsuccess=true
}
}

